"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBContentsTable", {
  enumerable: true,
  get: function get() {
    return _SVBContentsTable.default;
  }
});
var _SVBContentsTable = _interopRequireDefault(require("./src/SVBContentsTable"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }